"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = require("react");

const styles_1 = require("./styles");

const ProfileButton = (0, react_1.forwardRef)((props, ref) => {
  const {
    fallbackInitials,
    bgColor,
    textColor,
    onClick,
    firstName,
    lastName,
    fullName,
    email
  } = props;
  const initials = (0, react_1.useMemo)(() => {
    if (firstName && lastName) {
      return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }

    if (fullName) {
      const [fName, lName] = fullName.split(/\s/gi);
      return fName && lName && `${fName[0]}${lName[0]}`.toUpperCase();
    }

    if (email) {
      return email.slice(0, 2).toUpperCase();
    }

    return '';
  }, [firstName, lastName, fullName, email]);
  return (0, jsx_runtime_1.jsx)(styles_1.StyledButton, Object.assign({
    bgColor: bgColor,
    textColor: textColor,
    onClick: onClick,
    ref: ref
  }, {
    children: initials || fallbackInitials
  }), void 0);
});
exports.default = ProfileButton;